import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Conversation from "./routes/Conversation";

export default store => ({
  path: "ai-playground",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "ai-playground" */ "./components"),
      import(
        /* webpackChunkName: "ai-playground" */ "./modules/AIPlaygroundModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const aiPlaygroundModule = importedModule1;
      injectReducer(store, {
        key: aiPlaygroundModule.NAME,
        reducer: aiPlaygroundModule.default,
      });
      return component;
    })
  ),
  childRoutes: [Conversation(store)],
});
